import { Link } from 'react-router-dom';

import { LinkedPlatformsSection } from '@/features/account-link/LinkedPlatformsSection';
import { NotificationSettings } from '@/features/notifications/NotificationSettings';
import { DeleteAccountSection } from '@/features/profile/DeleteAccountSection';
import { ThemeSwitcher } from '@/features/theme/ThemeSwitcher';

export function SettingsPage() {
  return (
    <main className="flex flex-col">
      <h1 className="px-6 pt-8 font-display text-h1 text-text">Настройки</h1>

      <section aria-labelledby="appearance-heading" className="px-6 pt-6">
        <h2 id="appearance-heading" className="font-display text-h2 text-text">
          Оформление
        </h2>
        <p className="pt-1 pb-3 text-sm text-text-2">Выбор сохранится на этом устройстве.</p>
        <ThemeSwitcher />
      </section>

      <section aria-labelledby="notifications-heading" className="pt-8">
        <h2 id="notifications-heading" className="px-6 font-display text-h2 text-text">
          Уведомления
        </h2>
        <p className="px-6 pt-1 text-sm text-text-2">
          Выберите, о чём вам писать. Отключить можно в любой момент.
        </p>
        <NotificationSettings />
      </section>

      <LinkedPlatformsSection />
      <DeleteAccountSection />

      <div className="flex gap-4 border-t border-border px-6 py-6 text-xs text-text-3">
        <Link to="/privacy" className="hover:underline">
          Политика конфиденциальности
        </Link>
        <Link to="/terms" className="hover:underline">
          Условия использования
        </Link>
      </div>
    </main>
  );
}
